import { Component, OnInit } from '@angular/core';
import { Company } from '../../../../models/company';
import { Location } from '../../../../models/location';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../../models/paging/page';
import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';
import { LocationService } from '../../../../services/location.service';
import { RAMSService } from '../../../../services/rs/rams.service';
import { ReportableService } from '../../../../services/reportable.service';
import { Basket_Item } from '../../../../models/Basket_Item';
import { BasketService } from '../../../../services/rs/basket.service';
@Component({
  selector: 'app-rams',
  templateUrl: './rams.component.html',
  styleUrls: ['./rams.component.css']
})
export class RamsComponent implements OnInit {


  init:boolean;
  
  companies: Company[];
  locations: Location[];
  locationList: Location[];

  filter: any = {
    companyId: 0,
    locationId: 0,
    job_No: '',
    date_Range: 1,
    start_Date: moment().add(-1, 'months').toDate(),
    end_Date: moment().toDate(),
    //severe: false
  };

  page = new Page();
  rows = Array<any>();

  is_client = false;
  client;

  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService,
    public ramsService: RAMSService, public reportableService: ReportableService, public basketService: BasketService) {
    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "Created_At";


/*    companyService.getAll().then((data) => {
      this.companies = data;

      if (this.is_client) {
        this.filter.companyId = authService.currentUser.value.company_Id;
        this.filter.locationId = authService.currentUser.value.location_Id;
      }

      locationService.getAll().then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

        if (this.is_client) {
          this.locations = this.locationList.filter(c => {
            return c.company_Id == this.filter.companyId;
          });
        }
        this.loadTable(this.page);
      });
    });*/
  }

  ngOnInit() {
    this.loadTable(this.page);

      this.init = true;
    
  }

  onCompanyChange(value) {
    this.filter.location_Id = 0;
    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }


  // ###################################
  // TABLE
  // ###################################
  //getRowClass = (row) => {
  //  if (row.severe) {
  //    return {
  //      'row-color': true
  //    };
  //  }
  //}

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.ramsService.getResults(this.page, this.filter.companyId, this.filter.locationId,
      this.filter.job_No, this.filter.start_Date, this.filter.end_Date).then((pagedData) => {

        console.log(pagedData);
        this.page = pagedData.page;
        this.rows = pagedData.data;
        this.refreshbasketrow();
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }


  downloadRAMS(id: number) {
    this.reportableService.getRAMSReport(id).then((data) => {
      importedSaveAs(data, 'RISKS.pdf');
    });
  }

  dateChange(ev) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    this.filter.start_Date = jsDate;
  }
  //Basket
  addToBasket(item,type) {
    console.log(item);

    let basketItem = new Basket_Item();
    basketItem.id = -1;
    basketItem.guid = item.id;
    basketItem.description = item.engineer;
    basketItem.serial_Num = item.job_No;
    basketItem.category_Name = item.location;
    basketItem.is_Annual = item.is_Annual;
    basketItem.safe = true;
    basketItem.type = "RAMS";
    basketItem.report_Type = 3;
    basketItem.category_Id = 0;

    this.basketService.add(basketItem);
    item.addedrams = true;
  }
  removeFromBasket(item) {
    var basketItem = new Basket_Item();
    var items = this.basketService.getitems();
    console.log(items.value);

    for (let i = 0; i < (items.value.length); i++) {
      console.log(items.value[i]);
      if ((items.value[i].description == item.engineer) && (items.value[i].serial_Num == item.job_No)) {
        console.log("MATCHES");
        this.basketService.remove(items.value[i]);
      }
    }
    item.addedrams = false;
  }
  resetItem(item) {
    item.addedrams = false;
  }

  resetItems() {
    for (let item of this.rows) {
      this.resetItem(item);
    }
  }

  basketCompleted(data) {
    this.resetItems();
  }

  basketClearing(data) {
    this.resetItems();
  }

  //addAllToBasket() {
  //  this.ramsService.getAll(this.page, this.filter.company_Id, this.filter.location_Id,
  //    this.filter.job_No, this.filter.start_Date, this.filter.end_Date).then((pagedData) => {
  //      for (let i = 0; i < pagedData.length; i++) {
  //        const jsonObj = pagedData[i];
  //        console.log(jsonObj);
  //        if (jsonObj.id != null) {
  //          if (jsonObj.id != null && jsonObj.id != undefined)
  //            this.addToBasket(jsonObj, 3);
  //          if (jsonObj.engineer_Report_Id != null && jsonObj.engineer_Report_Id != undefined)
  //            this.addToBasket(jsonObj, 4);
  //          if (jsonObj.next_Inspection_Date != 'N/A' && jsonObj.next_Inspection_Date != undefined)
  //            this.addToBasket(jsonObj, 1);
  //        }
  //      }
  //      this.refreshbasketrow();
  //    });
  //}

  //generateExcel() {
  //  this.ramsService.getExcel(this.page, this.filter.company_Id, this.filter.location_Id,
  //    this.filter.job_No, this.filter.start_Date, this.filter.end_Date).then((data) => {
  //    importedSaveAs(data, 'Report.xlsx');
  //  });
  //}

  refreshbasketrow() {
    console.log("REFRESHING");
    var items = this.basketService.getitems();
    for (let i = 0; i < (this.rows.length); i++) {
      let row = this.rows[i];
      for (let k = 0; k < (items.value.length); k++) {
        let item = items.value[k];
        if (item.report_Type == 1) { //ROTE
          if ((item.description == row.description) && (item.serial_Num == row.serial_Num)) {
            this.rows[i].addedrote = true;
          }
        } else if (item.report_Type == 2) { //SERVICE
          if ((item.description == row.description) && (item.serial_Num == row.serial_Num)) {
            this.rows[i].addedservice = true;
          }
        } else if (item.report_Type == 3) { //RAMS
          if ((item.guid == row.ramS_Id) || (item.guid == row.id)) {
            this.rows[i].addedrams = true;
          }
        } else if (item.report_Type == 4) { //ERSTR
          if ((item.description == row.engineer) && (item.serial_Num == row.job_No)) {
            this.rows[i].addedestr = true;
          }
        }
      }

    }
  }


  basketOnclickEvent(ev) {
    console.log(ev);
    console.log("CLICKED");
    //   this.refreshbasketrow();
    for (let i = 0; i < (this.rows.length); i++) {
      let row = this.rows[i];
      if (ev.report_Type == 1) { //ROTE
        if ((ev.description == row.description) && (ev.serial_Num == row.serial_Num)) {
          this.rows[i].addedrote = false;
        }
      } else if (ev.report_Type == 2) { //SERVICE
        if ((ev.description == row.description) && (ev.serial_Num == row.serial_Num)) {
          this.rows[i].addedservice = false;
        }
      } else if (ev.report_Type == 3) { //RAMS
        if ((ev.guid == row.ramS_Id) || (ev.guid == row.id)) {
          this.rows[i].addedrams = false;
        }
      } else if (ev.report_Type == 4) { //ERSTR
        if ((ev.description == row.engineer) && (ev.serial_Num == row.job_No)) {
          this.rows[i].addedestr = false;
        }
      }
    }
  }
  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}


